import React, { Component } from "react";

// import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  EditorState,
  // ContentState,
  // convertFromHTML,
  // convertToRaw
} from "draft-js";
// import draftToHtml from "draftjs-to-html";
// import htmlToDraft from "html-to-draftjs";

import Button from "components/CustomButtons/Button";

import axios from "../../../config/axios";

import toastr from "toastr";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import GridItem from "components/Grid/GridItem.jsx";
import TextField from "@material-ui/core/TextField";
import GridContainer from "components/Grid/GridContainer.jsx";

import SimpleReactValidator from "simple-react-validator";
import loaderIcon from "assets/img/loader.gif";

import { hist } from "../../..";

const validationStyle = {
  color: "red"
};

/* Editor Component */
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ['link', 'image'],
    //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    ["blockquote", "code-block"],
    //[{ 'direction': 'rtl' }],                         // text direction
    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    ["clean"] // remove formatting button
  ],
    clipboard: {
    matchVisual: false
  },
};
class AddFAQ extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      editorState: EditorState.createEmpty(),
      action: "add",
      title: "",
      question: "",
      disabled: false,
      loading: false
    };
  }
  componentDidMount() {
    if (this.props.location.state) {
      const { action, faq } = this.props.location.state;
      console.log(faq.answer,'faq.answer');
      if (action === "edit" || action === "view") {
        this.setState({
          ...this.state,
          action,
          title: faq.title,
          question: faq.question,
          editorState: faq.answer
          // editorState: EditorState.createWithContent(
          //   ContentState.createFromBlockArray( htmlToDraft(faq.answer).contentBlocks)
          // )
        });
        if (action === "view") {
          this.setState({ disabled: true });
        }
      }
    }
  }

  inputHandler = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmitFAQ = () => {
    const { title, question, editorState, action } = this.state;

    // const data = encodeURIComponent(
    //   draftToHtml(convertToRaw(editorState.getCurrentContent()))
    // );
    const data = editorState;
    const requestBody = { title, question, answer: editorState };
    if (this.validator.allValid()) {
      this.setState({ loading: true });
      if (action === "edit") {
        const { faq } = this.props.location.state;
        axios
          .put(`faqs/${faq.id}`, requestBody)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              toastr.success("FAQ updated Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch(err => {
            this.setState({ loading: false });
            toastr.error(err.response.data.message + ". Please try again!");
          });
      } else {
        axios
          .post("faqs", requestBody)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              toastr.success("FAQ added Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch(err => {
            this.setState({ loading: false });
            toastr.error(err.response.data.message + ". Please try again!");
          });
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const { editorState, title, question, disabled, loading } = this.state;
    console.log(editorState,'editorState')
    return (
      <div className="add-category-form">
        <Card
          // className={classes.card}
          style={{ overflow: "-webkit-paged-x" }}
        >
          {loading ? (
            <div className="loader_icon">
              <img src={loaderIcon} alt="loader"/>
            </div>
          ) : (
            <React.Fragment>
              <CardContent>
                <form>
                  <GridContainer>
                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="title"
                        name="title"
                        label="Title*"
                        type="text"
                        fullWidth
                        value={title}
                        onChange={event => {
                          this.inputHandler(event);
                        }}
                        disabled={disabled}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message("Title", title, "required")}
                        </span>
                      }
                    </GridItem>
                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="question"
                        name="question"
                        label="Question*"
                        type="text"
                        fullWidth
                        value={question}
                        onChange={event => {
                          this.inputHandler(event);
                        }}
                        disabled={disabled}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "question",
                            question,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>
                    <GridItem md={12}>
                      <legend style={{ fontSize: "1rem" }}>Answer</legend>
                      <ReactQuill
                        onChange={(newValue, delta, source) => {
                          console.log("onChange newValue:::: ", newValue, delta)
                          this.setState({ 
                            ...this.state,
                            editorState: newValue });
                        }}
                        
                        onBlur={(range, source, quill) => {
                          //console.log("onBlur quill.getHTML():::: ", quill.getHTML(), range, source,quill, quill.getLength(), quill.getText())
                          console.log(quill.getHTML(),'quill.getHTML()');
                        }}
                        modules={modules}
                        theme="snow"
                        value={editorState}
                      />
                      {/* <Editor
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        editorState={editorState}
                        wrapperClassName="demo-wrapper"
                        editorClassName="demo-editor"
                        onEditorStateChange={editorState =>
                          this.setState({ editorState })
                        }
                        readOnly={disabled}
                      /> */}
                    </GridItem>
                  </GridContainer>
                </form>
                <p>
                  *Please upload the images only in 692px x 400px resolution
                </p>
              </CardContent>
              { !disabled ?
              <CardActions style={{ float: "right" }}>
                <Button
                  variant="contained"
                  color="iseas"
                  onClick={this.handleSubmitFAQ}
                >
                  Submit
                </Button>
              </CardActions>
              : null}
            </React.Fragment>
          )}
        </Card>
      </div>
    );
  }
}

export default AddFAQ;



// WEBPACK FOOTER //
// ./src/views/ISEAS/ContentBuilder/AddFAQ.js